import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, useFormikContext } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
  FormGroup,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { ReactstrapInput } from "reactstrap-formik";

import * as Yup from "yup";

import config from '../../store/config';
import FormHelpers from "../../helpers/FormHelpers";
import ScrollToFieldError from "./Validation/ScrollToFieldError";
import InfoTooltip from "../UI/Progress/InfoTooltip";

import { configuratorActions } from "../../store/configurator-slice";
import { sendCartData } from "../../store/configurator-actions";

function RequestForm() {
  const dispatch = useDispatch();

  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;

  const isUpdating = requestDetails.Id;

  const addingToCart = useSelector((state) => state.configurator.AddingToCart);

  // add to cart if no card
  useEffect(() => {
    if (addingToCart) {
      let currentCart = { ...requestDetails };
      dispatch(sendCartData(currentCart));
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [dispatch, addingToCart]);

  let defaultIntentionConfig = {
    placeholder: "",
    rows: 5,
    cols: 32,
    max: 1000,
  };

  let intentionMsg = 'Please Enroll (a person or a married couple)';
  if(requestDetails.CurrentMode === 'donotneed') {
    intentionMsg = 'Please Enroll (a person, married couple or family)';
  }

  const products = currentRequest.Products.filter(
    (item) => (item.EnrollmentGiftMode === requestDetails.CurrentMode || item.EnrollmentGiftMode === 'any')
  );

  const formRef = useRef(null);

  const [intentionConfig, setIntentionConfig] = useState(
    defaultIntentionConfig
  );

  const intentionRef = useRef(null);

  const validationRules = {
    intention: Yup.string().required("Required"),
    product: Yup.string().required("Please select an option")
  };

  const formSchema = Yup.object().shape(validationRules);

  const productClickHandler = (event) => {
    dispatch(configuratorActions.setProduct(event.target.value));
  };

  function formSubmitHandler(values) {
    // if request is a no card, add to cart right now and move to last step
    dispatch(configuratorActions.setRequest(values));
    FormHelpers.scrollToTop();
  }

  console.log(requestDetails);

  return (
    <div className="cfg-input-form cfg-request" data-step="request">
      <Formik
        initialValues={{
          intention: requestDetails.Intention,
          product: requestDetails.CurrentProduct
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form className="text-start">
            <ScrollToFieldError />
            <Container className="cfg-form-section">
              <Row className="mb-3">
                <Col xs="12">
                  <h4 className="required">
                    {intentionMsg}
                  </h4>
                  <FormGroup>
                    <Input
                      name="intention"
                      type="textarea"
                      id="intention"
                      ref={intentionRef}
                      datamax={intentionConfig.max}
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      value={values.intention}
                      rows={intentionConfig.rows}
                      cols={intentionConfig.cols}
                      className="cfg-intention-input parse-new-lines"
                      placeholder={intentionConfig.placeholder}
                      onKeyUp={FormHelpers.handleMultilineKeyUp}
                      onKeyDown={FormHelpers.handleMultilineKeyDown}
                      onPaste={FormHelpers.handleMultilineUpdate}
                      onChange={(e) => {
                        FormHelpers.handleMultilineUpdate(e);
                        handleChange(e);
                      }}
                      onBlur={(e) => {
                        FormHelpers.handleMultilineUpdate(e);
                        FormHelpers.cleanupEmptyLines(e, values, 'intention');
                        handleBlur(e);
                      }}
                      invalid={Boolean(
                        touched["intention"] && errors["intention"]
                      )}
                    />
                    {touched["intention"] && errors["intention"] ? (
                      <FormFeedback>{errors["intention"]}</FormFeedback>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="12">
                  <div className="mb-3">

                    {products.map((product) => (
                      <div className="form-check" key={product.SKUID}>
                        <label>
                          <Field
                            type="radio"
                            name="product"
                            readonly={isUpdating}
                            disabled={isUpdating}
                            value={product.SKUNumber}
                            onChange={(e) => {
                              productClickHandler(e);
                              handleChange(e);
                            }}
                          />
                          {product.SKUName} - ${Number(product.SKUPrice).toFixed(2)}
                        </label>
                      </div>
                    ))} 

                    {errors.product && touched.product && (
                      <div className="invalid-feedback">{errors.product}</div>
                    )}

                  </div>
                </Col>
              </Row>

              {/* <DebugOutput
                errors={errors}
                values={FormHelpers.getValues(values)}
              /> */}
            </Container>
            <Button
              type="submit"
              size="sm"
              color="primary"
              className="float-end"
            >
              {isUpdating ? "Update Cart" : "Add to Cart"}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default RequestForm;
